import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"
import annotationPlugin from "chartjs-plugin-annotation"
Chart.register(annotationPlugin)
export default class extends Controller {
  static values = {
    value: Number,
    max: Number
  }

  connect() {
    const ctx = this.element.getContext("2d")
    const value = this.valueValue
    const max = this.maxValue
    const annotation = {
      type: 'doughnutLabel',
      content: ({chart}) => [
        chart.data.datasets[0].data[0].toFixed(2) + ' %',
        'current year',
      ],
      drawTime: 'beforeDraw',
      position: {
        y: '0'
      },
      font: [{size: 40, weight: 'bold'}, {size: 16}],
      color: this.color()
    };
    this.chart = new Chart(ctx, {
      type: "doughnut",
      data: {
        datasets: [{
          data: [value, max - value],
          backgroundColor: [this.color(), "#E0E0E0"],
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "85%",
        rotation: -90,
        circumference: 180,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
          annotation:{
            annotations: {
          annotation
        }
          } 
        }
      }
    })
  }
  color(){
    if(this.valueValue >= 97.0){
      return "#0c8482"
    } else {
      return "red"
    }

  }

  disconnect() {
    this.chart?.destroy()
  }
}

